module.exports = __webpack_public_path__ + "media/images/competitions/competition_winner_badge-c45081dc4d305cd1bb75523126bf40c5.svg";